;(function () {
  'use strict'

  const hamburger = document.querySelector('.navbar__hamburger')
  const mobileNav = document.querySelector('.mobile-nav')
  const cartCountEl = document.querySelector('.navbar__cart-count')

  if (!hamburger || !mobileNav) return

  function setActiveLinks () {
    const path = window.location.pathname

    document.querySelectorAll('.navbar__link, .mobile-nav__link').forEach(link => {
      const href = link.getAttribute('href') || ''
      let linkPath
      try {
        linkPath = new URL(href, window.location.origin).pathname
      } catch (e) {
        linkPath = href
      }

      const isHomeLink = linkPath === '/' || linkPath.endsWith('/index.html')
      const isHomePage = path === '/' || path === ''

      const isMatch = isHomeLink
        ? isHomePage
        : path === linkPath

      if (isMatch) {
        link.setAttribute('aria-current', 'page')
      } else {
        link.removeAttribute('aria-current')
      }
    })
  }

  function openNav () {
    mobileNav.classList.add('is-open')
    mobileNav.setAttribute('aria-hidden', 'false')
    hamburger.setAttribute('aria-expanded', 'true')
    hamburger.setAttribute('aria-label', 'Close navigation menu')
    document.body.classList.add('nav-open')

    var navSection = hamburger.closest('.shopify-section') || hamburger.closest('header')
    document.querySelectorAll('body > *').forEach(el => {
      if (el === navSection || el.contains(mobileNav) || el.contains(hamburger)) return
      if (el.tagName === 'SCRIPT' || el.tagName === 'LINK' || el.tagName === 'STYLE') return
      el.setAttribute('inert', '')
    })

    const first = mobileNav.querySelector('.mobile-nav__link')
    if (first) first.focus()
  }

  function closeNav () {
    mobileNav.classList.remove('is-open')
    mobileNav.setAttribute('aria-hidden', 'true')
    hamburger.setAttribute('aria-expanded', 'false')
    hamburger.setAttribute('aria-label', 'Open navigation menu')
    document.body.classList.remove('nav-open')

    document.querySelectorAll('[inert]').forEach(el => {
      el.removeAttribute('inert')
    })

    hamburger.focus()
  }

  hamburger.addEventListener('click', () => {
    mobileNav.classList.contains('is-open') ? closeNav() : openNav()
  })

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && mobileNav.classList.contains('is-open')) {
      closeNav()
    }
  })

  mobileNav.querySelectorAll('.mobile-nav__link').forEach(link => {
    link.addEventListener('click', closeNav)
  })

  window.nonnomCart = {
    setCount (count) {
      if (!cartCountEl) return
      const n = Math.max(0, Math.floor(count))
      cartCountEl.setAttribute('data-count', n)
      cartCountEl.textContent = n > 99 ? '99+' : String(n)

      const cartBtn = cartCountEl.closest('.navbar__icon-btn')
      if (cartBtn) {
        cartBtn.setAttribute(
          'aria-label',
          n === 0 ? 'Cart, empty' : `Cart, ${n} item${n === 1 ? '' : 's'}`
        )
      }
    }
  }

  setActiveLinks()
  window.nonnomCart.setCount(0)

})();

(function () {
  'use strict';

  var overlay    = document.getElementById('cart-overlay');
  var drawer     = document.getElementById('cart-drawer');
  var closeBtn   = document.getElementById('cart-drawer-close');
  var drawerBody = document.getElementById('cart-drawer-body');
  var subtotalEl = document.getElementById('cart-subtotal');

  function openDrawer() {
    if (!overlay || !drawer) return;
    fetchAndRender();
    overlay.classList.add('is-open');
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-open');
    var focusTarget = drawer.querySelector('button, a, [tabindex]');
    if (focusTarget) setTimeout(function() { focusTarget.focus(); }, 50);
  }

  function closeDrawer() {
    if (!overlay || !drawer) return;
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-open');
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var fmt = window.NomNom && window.NomNom.moneyFormat ? window.NomNom.moneyFormat : '${{amount}}';
    var code = window.NomNom && window.NomNom.currencyCode ? ' ' + window.NomNom.currencyCode : '';
    return fmt.replace('{{amount}}', amount).replace('{{amount_no_decimals}}', Math.round(cents / 100)) + code;
  }

  function renderItems(cart) {
    if (!drawerBody) return;

    if (!cart.items || cart.items.length === 0) {
      drawerBody.innerHTML = [
        '<div class="cart-drawer__empty">',
          '<p class="cart-drawer__empty-text">YOUR BAG IS EMPTY</p>',
          '<p class="cart-drawer__empty-sub">Adventure awaits, start collecting!</p>',
        '</div>'
      ].join('');
      if (subtotalEl) subtotalEl.textContent = '';
      return;
    }

    var itemsHTML = cart.items.map(function(item, i) {
      var imgHTML = item.featured_image && item.featured_image.url
        ? '<img class="cart-item__img" src="' + item.featured_image.url + '" alt="' + _esc(item.product_title) + '" loading="lazy">'
        : '<div class="cart-item__img-placeholder"></div>';

      var variantLine = item.variant_title && item.variant_title !== 'Default Title'
        ? '<p class="cart-item__variant">' + _esc(item.variant_title) + '</p>'
        : '';

      return [
        '<div class="cart-item">',
          imgHTML,
          '<div class="cart-item__info">',
            '<p class="cart-item__name">' + _esc(item.product_title) + '</p>',
            variantLine,
            '<div class="cart-item__price-row">',
              '<div class="cart-item__price">',
                '<span class="cart-item__price-amount">' + formatMoney(item.final_line_price) + '</span>',
              '</div>',
              '<div class="cart-item__qty">',
                '<button class="cart-item__qty-btn" type="button"',
                        ' data-line="' + (i + 1) + '" data-action="dec"',
                        ' aria-label="Decrease quantity">&#8722;</button>',
                '<span class="cart-item__qty-value">' + item.quantity + '</span>',
                '<button class="cart-item__qty-btn" type="button"',
                        ' data-line="' + (i + 1) + '" data-action="inc"',
                        ' aria-label="Increase quantity">&#43;</button>',
              '</div>',
              '<button class="cart-item__remove" type="button"',
                      ' data-line="' + (i + 1) + '"',
                      ' aria-label="Remove ' + _esc(item.product_title) + '">REMOVE</button>',
            '</div>',
          '</div>',
        '</div>'
      ].join('');
    }).join('');

    drawerBody.innerHTML = '<div class="cart-drawer__items">' + itemsHTML + '</div>';

    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    drawerBody.querySelectorAll('.cart-item__qty-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var line    = parseInt(btn.dataset.line, 10);
        var action  = btn.dataset.action;
        var qtyEl   = btn.closest('.cart-item__qty').querySelector('.cart-item__qty-value');
        var current = parseInt(qtyEl ? qtyEl.textContent : '1', 10);
        var newQty  = action === 'inc' ? current + 1 : Math.max(0, current - 1);
        changeLine(line, newQty);
      });
    });

    drawerBody.querySelectorAll('.cart-item__remove').forEach(function(btn) {
      btn.addEventListener('click', function() {
        changeLine(parseInt(btn.dataset.line, 10), 0);
      });
    });
  }

  function changeLine(line, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ line: line, quantity: qty })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      renderItems(cart);
      if (window.nonnomCart) window.nonnomCart.setCount(cart.item_count);
    })
    .catch(function() {});
  }

  function add(variantId, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: qty || 1 })
    })
    .then(function(r) {
      if (!r.ok) {
        return r.json().then(function(d) {
          throw new Error(d.description || 'Could not add item to cart');
        });
      }
      return r.json();
    })
    .then(function() {
      return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      renderItems(cart);
      if (window.nonnomCart) window.nonnomCart.setCount(cart.item_count);
      return cart;
    });
  }

  function fetchAndRender() {
    return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        renderItems(cart);
        if (window.nonnomCart) window.nonnomCart.setCount(cart.item_count);
        return cart;
      })
      .catch(function() {});
  }

  function _esc(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#x27;');
  }

  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay)  overlay.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  /* Wire navbar cart button (data-cart-trigger attribute) */
  document.querySelectorAll('[data-cart-trigger]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      openDrawer();
    });
  });

  window.nonnomCartAPI = {
    add:          add,
    openDrawer:   openDrawer,
    closeDrawer:  closeDrawer,
    fetchAndRender: fetchAndRender
  };

  fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      if (window.nonnomCart) window.nonnomCart.setCount(cart.item_count);
    })
    .catch(function() {});

})();




(function () {
  var wrap = document.querySelector('[data-currency-select]');
  if (!wrap) return;

  var trigger  = wrap.querySelector('.currency-select__trigger');
  var dropdown = wrap.querySelector('.currency-select__dropdown');

  function open()  { dropdown.hidden = false; trigger.setAttribute('aria-expanded', 'true'); }
  function close() { dropdown.hidden = true;  trigger.setAttribute('aria-expanded', 'false'); }
  function toggle() { dropdown.hidden ? open() : close(); }

  trigger.addEventListener('click', function (e) {
    e.stopPropagation();
    toggle();
  });

  /* Close on outside click */
  document.addEventListener('click', function (e) {
    if (!wrap.contains(e.target)) close();
  });

  /* Close on Escape */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });
})();


(function () {
  var STORAGE_KEY  = 'nomnom_subscribed';
  var DISMISS_KEY  = 'nomnom_popup_dismissed';

    /* Subscription state */
  function getSubState() {
    try { return localStorage.getItem(STORAGE_KEY) || ''; } catch (e) { return ''; }
  }

  function isSubscribed() {
    var state = getSubState();
    return state === 'pending' || state === 'confirmed';
  }

  function isConfirmed() {
    return getSubState() === 'confirmed';
  }

  function setSubscribed() {
    try { localStorage.setItem(STORAGE_KEY, 'pending'); } catch (e) {}
  }

  function setConfirmed() {
    try { localStorage.setItem(STORAGE_KEY, 'confirmed'); } catch (e) {}
  }

  function isDismissed() {
    try { return sessionStorage.getItem(DISMISS_KEY) === 'true'; } catch (e) { return false; }
  }

  function setDismissed() {
    try { sessionStorage.setItem(DISMISS_KEY, 'true'); } catch (e) {}
  }try {
    var navEntry = performance.getEntriesByType('navigation')[0];
    if (navEntry && navEntry.type === 'reload') {
      sessionStorage.removeItem(DISMISS_KEY);
    }
  } catch (e) {}

    /* Footer state */
  function showSubscribedFooter() {
    var wrap = document.getElementById('footer-newsletter-wrap');
    var done = document.getElementById('footer-subscribed');
    var pending = document.getElementById('footer-pending');
    if (wrap) wrap.hidden = true;
    if (isConfirmed()) {
      if (done) done.hidden = false;
      if (pending) pending.hidden = true;
    } else {
      if (done) done.hidden = true;
      if (pending) pending.hidden = false;
    }
  }

  /* Detect confirmation page — upgrade pending to confirmed */
  if (window.location.pathname.indexOf('/account/subscribe') >= 0) {
    setConfirmed();
  }

  if (isSubscribed()) {
    showSubscribedFooter();
  }

    /* Footer form */
  var footerForm  = document.getElementById('footer-newsletter');
  if (footerForm && !isSubscribed()) {
    var footerInput = footerForm.querySelector('input[type="email"]');

    footerForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = footerInput ? footerInput.value.trim() : '';
      if (!email || email.indexOf('@') < 1 || email.indexOf('.') <= email.indexOf('@') + 1) {
        if (footerInput) { footerInput.classList.add('is-error'); footerInput.focus(); }
        return;
      }
      if (footerInput) footerInput.classList.remove('is-error');

      var formData = new FormData(footerForm);
      fetch(footerForm.action, { method: 'POST', body: formData, headers: { 'Accept': 'text/html' } })
        .then(function () {
          /* Shopify received the submission — mark as subscribed */
          setSubscribed();
          showSubscribedFooter();
        })
        .catch(function () {
          /* Network error — still try to mark since Shopify may have received it */
          setSubscribed();
          showSubscribedFooter();
        });
    });
  }

  /* Popup */
  var popup       = document.getElementById('subscribe-popup');
  var popupClose  = document.getElementById('subscribe-popup-close');
  var popupDone   = document.getElementById('subscribe-popup-done');
  var popupDrop   = document.getElementById('subscribe-popup-backdrop');
  var popupContent= document.getElementById('subscribe-popup-content');
  var popupSuccess= document.getElementById('subscribe-popup-success');

  if (!popup) return;

  var isCatalogue = document.querySelector('.catalogue__shell') !== null;
  if (!isCatalogue || isSubscribed() || isDismissed()) return;

  function showPopup() {
    popup.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function hidePopup(wasDismiss) {
    popup.hidden = true;
    document.body.style.overflow = '';
    if (wasDismiss) setDismissed();
  }

  /* Show after 3 seconds on catalogue */
  setTimeout(showPopup, 3000);

  popupClose.addEventListener('click', function () { hidePopup(true); });
  popupDrop.addEventListener('click', function () { hidePopup(true); });
  if (popupDone) popupDone.addEventListener('click', function () { hidePopup(false); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !popup.hidden) hidePopup(true);
  });

  /* Popup subscribe — uses its own Shopify form */
  var popupFormEl = document.getElementById('popup-newsletter');

  if (popupFormEl) {
    popupFormEl.addEventListener('submit', function (e) {
      e.preventDefault();
      var popupInput = popupFormEl.querySelector('input[type="email"]');
      var email = popupInput ? popupInput.value.trim() : '';

      if (!email || email.indexOf('@') < 1 || email.indexOf('.') <= email.indexOf('@') + 1) {
        if (popupInput) { popupInput.classList.add('is-error'); popupInput.focus(); }
        return;
      }
      if (popupInput) popupInput.classList.remove('is-error');

      var fd = new FormData(popupFormEl);
      fetch(popupFormEl.action, { method: 'POST', body: fd, headers: { 'Accept': 'text/html' } })
        .then(function () {
          setSubscribed();
          showSubscribedFooter();
          popupContent.hidden = true;
          popupSuccess.hidden = false;
          setTimeout(function () { hidePopup(false); }, 3000);
        })
        .catch(function () {
          setSubscribed();
          showSubscribedFooter();
          popupContent.hidden = true;
          popupSuccess.hidden = false;
          setTimeout(function () { hidePopup(false); }, 3000);
        });
    });
  }
})();
